import { IFeature } from 'mod/featureV2/interface';

export const buyButton: IFeature = {
    moduleId: 'buyButton_1',
    type: 'buyButton',
    title: 'buyButton',
    description: 'buy Button description',
    config: {
        type: 'buyNow',
        text: 'Checkout',
        wrapStyles: {
            textAlign: 'center',
        },
        btnProps: {
            style: {
                width: '200px',
                lineHeight: '40px',
                height: '40px',
                fontSize: '24px',
                background: 'pink',
                borderColor: 'pink',
                color: 'red',
            }
        },
        soldOutBtnProps: {
            style: {
                margin: '0 10px 16px 0',
                padding: '0 20px',
                height: '40px',
                lineHeight: '38px',
                borderRadius: '20px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: ' #05DA54',
            }
        }
    },
};

export const buyButton2: IFeature = {
    ...buyButton,
    moduleId: 'buyButton2',
    title: 'buyButton checkout button',
    description: 'checkout description',
    config: {
        ...buyButton.config,
        type: 'addToCart',
        text: 'Add to Cart',
        btnProps: {
            type: 'primary'
        },
    }
};
